import { IState } from 'app/cross-cutting-concerns/state-management/interfaces/IState';

export const selectIsContractObligationModalVisible = (state: IState): boolean =>
  state.modules['terms-conditions'].modals.contractObligation.visible;

export const selectIsLicenseAgreementModalVisible = (state: IState): boolean =>
  state.modules['terms-conditions'].modals.licenseAgreement.visible;
